import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import {deviceMax} from '../../theme/breakpoints'

export const StyledLanguages = styled.div`
  position: relative;
  flex-direction: row;
  align-items: center;
  display: flex;
  width: fit-content;
  height: ${pxToRem(49)};
  padding: 0 ${pxToRem(32)} 0 0;
  border-radius: 0 ${pxToRem(39)} ${pxToRem(39)} 0;
  background-color: ${({theme}) => theme.colors.unique.white};
  @media ${deviceMax.tablet} {
    padding-left: ${pxToRem(20)};
  }
`

export const WhiteSpace = styled.div`
  position: absolute;
  z-index: 0;
  left: 0;
  margin-left: -200%;
  padding-left: 200%;
  height: ${pxToRem(49)};
  background-color: ${({theme}) => theme.colors.unique.white};
`

export const StyledLanguageItem = styled.a`
  cursor: pointer;
  margin: 0 ${pxToRem(10)};
  font-size: ${({theme}) => theme.fonts.sizes.base};
  font-weight: ${({theme}) => theme.fonts.weight.medium};
`

export const LocalesContainer = styled.div`
  position: relative;
  margin: 0;
`
